import React, { useRef, useState } from "react";
import { TextField, Button, Box, Typography, Grid, Select, MenuItem, Checkbox, ListItemText, FormControl, InputLabel, OutlinedInput } from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  updateCampaignMasterDataApi,
  getCampaign,
} from "../../redux/features/clicksSlice";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "80%", md: "60%", lg: "50%" },
  bgcolor: "background.paper",
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  overflowY: "auto",
  maxHeight: "90vh",
  borderRadius: "10px",
};
const UpdateModule = ({ handleClose, updateId, campaignMasterUpdate }) => {
  // console.log(campaignMasterUpdate, updateId, "testimonialtoupdate");
  const dispatch = useDispatch();

  // console.log(campaignMasterUpdate[0],"zero hai ye")

  // const [status, setStatus] = useState("1");
  const site_nameRef = useRef(null);
  const host_mid_nameRef = useRef(null);
  const url_matchRef = useRef(null);
  const table_nameRef = useRef(null);
  const cart_urlRef = useRef(null);
  const order_page_urlRef = useRef(null);
  const fb_pixel_idRef = useRef(null);
  const fb_pixel_pagesRef = useRef(null);
  const blocked_pagesRef = useRef(null);
  const session_wt_minRef = useRef(null);
  const live_onRef = useRef(null);
  const cashback_affRef = useRef(null);
  const normal_page_per_kRef = useRef(null);
  const cart_page_perRef = useRef(null);
  const min_no_visitsRef = useRef(null);
  const countryRef = useRef(null);
  const country_exceptRef = useRef(null);
  
  const [selectedDevices, setSelectedDevices] = useState(
    campaignMasterUpdate[19] ? campaignMasterUpdate[19].split(",").map(d => d.trim()).filter(Boolean) : []
  );

  const handleDeviceChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedDevices(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const black_list_aff_wait_minRef = useRef(null);
  const our_aff_wait_minRef = useRef(null);
  const aff_activeRef = useRef(null);
  const retargetting_activeRef = useRef(null);
  const data_actRef = useRef(null);
  const aff_wait_hrRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // -------Adding inputvalues to form data OBJ-----//
    const formData = {};
    formData.id = updateId;
    formData.site_name = site_nameRef.current ? site_nameRef.current.value : "";
    formData.site_name = site_nameRef.current ? site_nameRef.current.value : "";
    formData.host_mid_name = host_mid_nameRef.current
      ? host_mid_nameRef.current.value
      : "";
    formData.url_match = url_matchRef.current ? url_matchRef.current.value : "";
    formData.table_name = table_nameRef.current
      ? table_nameRef.current.value
      : "";
    formData.cart_url = cart_urlRef.current ? cart_urlRef.current.value : "";
    formData.order_page_url = order_page_urlRef.current ? order_page_urlRef.current.value : "";
    formData.fb_pixel_id = fb_pixel_idRef.current ? fb_pixel_idRef.current.value : "";
    formData.fb_pixel_pages = fb_pixel_pagesRef.current ? fb_pixel_pagesRef.current.value : "";
    formData.blocked_pages = blocked_pagesRef.current ? blocked_pagesRef.current.value : "";
    formData.session_wt_min = session_wt_minRef.current ? session_wt_minRef.current.value : "";
    formData.live_on = live_onRef.current ? live_onRef.current.value : "";
    formData.cashback_aff = cashback_affRef.current
      ? cashback_affRef.current.value
      : "";
    formData.normal_page_per_k = normal_page_per_kRef.current
      ? normal_page_per_kRef.current.value
      : "";
    formData.cart_page_per = cart_page_perRef.current
      ? cart_page_perRef.current.value
      : "";
    formData.min_no_visits = min_no_visitsRef.current
      ? min_no_visitsRef.current.value
      : "";
    formData.country = countryRef.current ? countryRef.current.value : "";
    formData.country_except = country_exceptRef.current
      ? country_exceptRef.current.value
      : "";
    formData.device = selectedDevices.join(",");
    formData.black_list_aff_wait_min = black_list_aff_wait_minRef.current
      ? black_list_aff_wait_minRef.current.value
      : "";
    formData.our_aff_wait_min = our_aff_wait_minRef.current
      ? our_aff_wait_minRef.current.value
      : "";
    formData.aff_active = aff_activeRef.current
      ? aff_activeRef.current.value
      : "";
    formData.retargetting_active = retargetting_activeRef.current
      ? retargetting_activeRef.current.value
      : "";
    formData.data_act = data_actRef.current ? data_actRef.current.value : "";
    formData.aff_wait_hr = aff_wait_hrRef.current
      ? aff_wait_hrRef.current.value
      : "";

    // -------Adding inputvalues to form data OBJ-----//
    // console.log(formData, "formDataformData");
    try {
      dispatch(updateCampaignMasterDataApi(formData)).then((data) => {
        dispatch(getCampaign());
        handleClose();
        toast.success("Updated Successfully!", {
          position: "top-center",
          autoClose: 3000,
        });
      });
    } catch (error) {
      toast.error("Something went wrong!", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  return (
    <div>
      <Box sx={style}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">
            Updating Campaign with ID- {updateId}
          </Typography>
          <Button color="error" onClick={handleClose}>
            <CancelOutlinedIcon />
          </Button>
        </div>

        <form
          onSubmit={handleSubmit}
          encType="multipart/form-data"
          style={{
            backgroundColor: "#f9f9f9",
            padding: "20px",
            margin: "10px 0",
            display: "flex",
            flexDirection: "column",
            borderRadius: "8px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="site_name"
                defaultValue={campaignMasterUpdate[2]}
                inputRef={site_nameRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="host_mid_name"
                defaultValue={campaignMasterUpdate[3]}
                inputRef={host_mid_nameRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="url_match"
                defaultValue={campaignMasterUpdate[4]}
                inputRef={url_matchRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="table_name"
                defaultValue={campaignMasterUpdate[5]}
                inputRef={table_nameRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="cart_url"
                defaultValue={campaignMasterUpdate[6]}
                inputRef={cart_urlRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="order_page_url"
                defaultValue={campaignMasterUpdate[7]}
                inputRef={order_page_urlRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="fb_pixel_id"
                defaultValue={campaignMasterUpdate[8]}
                inputRef={fb_pixel_idRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="fb_pixel_pages"
                defaultValue={campaignMasterUpdate[9]}
                inputRef={fb_pixel_pagesRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="blocked_pages"
                defaultValue={campaignMasterUpdate[10]}
                inputRef={blocked_pagesRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="session_wt_min"
                defaultValue={campaignMasterUpdate[11]}
                inputRef={session_wt_minRef}
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="live_on"
                defaultValue={campaignMasterUpdate[12]}
                inputRef={live_onRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="cashback_aff"
                defaultValue={campaignMasterUpdate[13]}
                inputRef={cashback_affRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="normal_page_per_k"
                defaultValue={campaignMasterUpdate[14]}
                inputRef={normal_page_per_kRef}
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="cart_page_per"
                defaultValue={campaignMasterUpdate[15]}
                inputRef={cart_page_perRef}
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="min_no_visits"
                defaultValue={campaignMasterUpdate[16]}
                inputRef={min_no_visitsRef}
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="country"
                defaultValue={campaignMasterUpdate[17]}
                inputRef={countryRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="country_except"
                defaultValue={campaignMasterUpdate[18]}
                inputRef={country_exceptRef}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="device-multiple-label">Device</InputLabel>
                <Select
                  labelId="device-multiple-label"
                  multiple
                  value={selectedDevices}
                  onChange={handleDeviceChange}
                  input={<OutlinedInput label="Device" />}
                  renderValue={(selected) => selected.join(", ")}
                >
                  {["Desktop", "Mobile", "Tablet", "SmartTV"].map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={selectedDevices.indexOf(name) > -1} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="black_list_aff_wait_min"
                defaultValue={campaignMasterUpdate[20]}
                inputRef={black_list_aff_wait_minRef}
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="our_aff_wait_min"
                defaultValue={campaignMasterUpdate[21]}
                inputRef={our_aff_wait_minRef}
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="aff_active"
                defaultValue={campaignMasterUpdate[22]}
                inputRef={aff_activeRef}
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="retargetting_active"
                defaultValue={campaignMasterUpdate[23]}
                inputRef={retargetting_activeRef}
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="data_act"
                defaultValue={campaignMasterUpdate[24]}
                inputRef={data_actRef}
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="aff_wait_hr"
                defaultValue={campaignMasterUpdate[25]}
                inputRef={aff_wait_hrRef}
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                size="large"
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  );
};

export default UpdateModule;
